export default "__VITE_ASSET__DT1R9rMW__"